<div class="wpr">
  <div class="glb-page-warning-box1">
    <div class="glb-page-warning-box1-col1"> <img src="assets/images/timeOut.png" alt="">
      <h2>Your Unauthorized</h2>
      <span class="glb-btn">
        <span class="btn primary-button" onclick="location.href='https://myhcltech.com'">BACK TO MyHCLTech</span>
      </span>
    </div>
  </div>
</div>